import ibptMetadata from './data/metadata.json';
import type { IbptDataVersion } from './types.js';

export const IBPT_DATA_VERSION: IbptDataVersion = ibptMetadata as IbptDataVersion;
